import { render, staticRenderFns } from "./StorageCard.vue?vue&type=template&id=c207b74c&scoped=true&"
import script from "./StorageCard.vue?vue&type=script&lang=ts&"
export * from "./StorageCard.vue?vue&type=script&lang=ts&"
import style0 from "./StorageCard.vue?vue&type=style&index=0&id=c207b74c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c207b74c",
  null
  
)

export default component.exports